import { useState, useEffect } from "react";
import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import CssClass from "../../Styles/common.module.css";
import SystemInfoModify from "./SystemInfoModify";
import SystemInfoDelete from "./SystemInfoDelete";
import SystemInfoActivator from "./SystemInfoActivator";
import edit from "../../assets/edit-icon.png";
import deleteIcon from "../../assets/delete-icon.png";
import moment from "moment";

const SystemInfoListTable = (props) => {

    //#region React Hooks
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showActivator, setShowActivator] = useState(false);
    const [editData, setEditData] = useState([]);
    //#endregion

    //#region Modal Show/Hide
    const showEditModal = (e, row) => {

        setShowEdit(!showEdit);
        setEditData(row);
    };

    const hideEditModal = () => {
        setShowEdit(!showEdit);
        setEditData(null);
    };

    const showActivatorModal = (e, row) => {
        setShowActivator(!showActivator);
        setEditData(row);
    };

    const hideActivatorModal = () => {
        setShowActivator(!showActivator);
        setEditData(null);
    };

    const showDeleteModal = (e, row) => {
        setShowDelete(!showDelete);
        setEditData(row);
    };

    const hideDeleteModal = () => {
        setShowDelete(!showDelete);
        setEditData(null);
    };
    //#endregion

    //#region Table Columns
    const columns = [
        {
            accessorKey: "SYSTEM_MST_NAME",
            header: "System Name",
            size: 120,
        },
        {
            accessorKey: "SERVER_ENV_NAME",
            header: "Prod. / Dev.",
            size: 120,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                let bgColor = "transparent";

                if (value?.toLowerCase().includes("prod")) {
                    bgColor = "#ff0000"; // Red
                } else if (value?.toLowerCase().includes("dev")) {
                    bgColor = "#ffff00"; // Yellow
                }

                return (
                    <div
                        style={{
                            backgroundColor: bgColor,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            padding: "8px",
                            boxSizing: "border-box",
                        }}
                    >
                        {value}
                    </div>
                );
            },
        },

        {
            accessorKey: "SERVER_CONN_TYPE_NAME",
            header: "Type",
            size: 120,
        },
        {
            id: "IP_URL",
            header: "IP / URL",
            size: 120,
            accessorFn: (row) => {
                const ip = row.IP_ADDRESS || "";
                const url = row.URL || "";

                return (
                    <div>
                        <div>
                            <span
                                /*Select Whole Column Value*/
                                className={CssClass.selectAll}
                                onDoubleClick={(e) => {
                                    const range = document.createRange();
                                    range.selectNodeContents(e.target);
                                    const sel = window.getSelection();
                                    sel.removeAllRanges();
                                    sel.addRange(range);
                                }}
                            >
                            {ip}
                            </span>
                        </div>
                        <div>
                            {url ? (
                                <a
                                    href={url.startsWith("http") ? url : `http://${url}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "blue", textDecoration: "underline" }}
                                >
                                    {url}
                                </a>
                            ) : null}
                        </div>
                    </div>
                );
            },
        },


        {
            accessorKey: "ID",
            header: "ID",
            size: 120,
            /*Select Whole Column Value*/
            Cell: ({ cell }) => (
                <span
                    className={CssClass.selectAll}          
                    onDoubleClick={(e) => {                 
                        const range = document.createRange(); 
                        range.selectNodeContents(e.target);
                        const sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }}
                    >
                {cell.getValue()}
                </span>
            ),
        },
        {
            accessorKey: "PASSWORD",
            header: "Password",
            size: 120,
            /*Select Whole Column Value*/
            Cell: ({ cell }) => (
                <span
                    className={CssClass.selectAll}          
                    onDoubleClick={(e) => {                 
                        const range = document.createRange(); 
                        range.selectNodeContents(e.target);
                        const sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }}
                    >
                {cell.getValue()}
                </span>
            ),
        },

        {
            accessorKey: "DB_SID",
            header: "DB - SID",
            size: 120,
            /*Select Whole Column Value*/
            Cell: ({ cell }) => (
                <span
                    className={CssClass.selectAll}          
                    onDoubleClick={(e) => {                 
                        const range = document.createRange(); 
                        range.selectNodeContents(e.target);
                        const sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }}
                    >
                {cell.getValue()}
                </span>
            ),
        },
        {
            accessorKey: "REMARK",
            header: "Remark",
            size: 120,
            /*Select Whole Column Value*/
            Cell: ({ cell }) => (
                <span
                    className={CssClass.selectAll}          
                    onDoubleClick={(e) => {                 
                        const range = document.createRange(); 
                        range.selectNodeContents(e.target);
                        const sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }}
                    >
                {cell.getValue()}
                </span>
            ),
        },
        // {
        // 	accessorKey: "ORGANIZATION_SYSTEM",
        // 	header: "Organization System",
        // 	size: 120,
        // },
        {
            id: "STATUS",
            header: "Status",
            size: 80,
            accessorFn: (row) => {
              const className =
                row.STATUS === "Active"
                  ? CssClass.activeStatus
                  : CssClass.inactiveStatus;

                const handleActivatorClick = (e, row) => {
                    showActivatorModal(e, row);
                };

              return (

                <div className={CssClass.toggleWrapper}>
                  {/* <span className={className}>{row.STATUS}</span> */}
                  <label className={CssClass.switch}>
                    <input
                      type="checkbox"
                      checked={row.STATUS === "Active"}
                      onChange={(e) => handleActivatorClick(e, row)}
                    />
                    <span className={CssClass.sliderRound}></span>
                  </label>
                </div>
              );
            },
          },
        // {
        //     accessorKey: "UPDATE_NAME",
        //     header: "Last Update By",
        //     size: 120,
        // },
        // {
        //     accessorKey: "UPDATE_DATETIME",
        //     header: "Last Update Date Time",
        //     size: 200,
        //     Cell: ({ cell }) =>
        //         cell.getValue() === "0001-01-01T00:00:00"
        //           ? "-"
        //           : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
        // },
        {
            id: "Action",
            header: "Action",
            size: 150,
            classes: CssClass.tdBtnActionWrapperOne,
            accessorFn: (row) => (
                <div>
                    <span>
                        <span title="Modify">
                            <Comp.Button
                                id="btnEdit"
                                type="general"
                                onClick={(e) => showEditModal(e, row)}
                                style={{ width: "60px", height: "40px" }}
                            >
                                <img src={edit} alt="Edit" style={{ width: "22px", height: "22px" }} />
                            </Comp.Button>
                        </span>
                        {/* <Comp.Button
                            id="btnActivator"
                            type="activator"
                            onClick={(e) => showActivatorModal(e, row)}
                         >
                            {row.ACTIVE_FLAG === "Y" ? "DEACTIVATE" : "ACTIVATE"}
                        </Comp.Button>						 */}
                        <span title="Delete">
                            <Comp.Button
                                id="btnDelete"
                                type="delete"
                                onClick={(e) => showDeleteModal(e, row)}
                                style={{ width: "60px", height: "40px" }}
                            >
                                <img src={deleteIcon} alt="Unlock" style={{ width: "26px", height: "26px" }} />
                            </Comp.Button>
                        </span>
                    </span>
                </div>
            ),
        },
    ];
    //#endregion

    return (
        <>
            <Comp.Table
                columns={columns}
                data={props.data}
                invisibleCol={{ Action: (props.actionAuthority.WRITE !== "Y") ? false : true }}
                onReload={props.onReload}
            />
            <SystemInfoModify
                page={props.page}
                module={props.module}
                showHide={showEdit}
                editData={editData}
                dataToBeSelect={props.dataToBeSelect}
                onHide={hideEditModal}
                onReload={props.onReload}
                onLoading={props.onLoading}
            />
            <SystemInfoActivator
                page={props.page}
                module={props.module}
                showHide={showActivator}
                editData={editData}
                onHide={hideActivatorModal}
                onReload={props.onReload}
                onLoading={props.onLoading}
            />
            <SystemInfoDelete
                page={props.page}
                module={props.module}
                showHide={showDelete}
                editData={editData}
                onHide={hideDeleteModal}
                onReload={props.onReload}
                onLoading={props.onLoading}
            />
        </>
    );
};

export default SystemInfoListTable;